@if (isLoading | async) {
	<div class="overlay"></div>
	<div class="spinner">
		<div
			class="spinner-border text-primary"
			role="status"
		>
			<span class="visually-hidden">Loading...</span>
		</div>
	</div>
}
